import {airBlue, lightGray} from '@modifi/colors'
import {NextIcon} from '@modifi/ui'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${lightGray};
  border-radius: 6px;
  min-width: 168px;
  cursor: pointer;
  padding: 14px;
  margin: 0 8px;
`

type DropdownArrowProps = {
  isOpen?: boolean
}

export const DropdownArrow = styled(NextIcon)<DropdownArrowProps>`
  transition: transform 1s ease;
  transform: rotate(${({isOpen}): number => (isOpen ? 270 : 90)}deg);
  color: ${airBlue};
`
